import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M21 12c-6.597 0 -9 2.403 -9 9c0 -6.597 -2.403 -9 -9 -9c6.597 0 9 -2.403 9 -9c0 6.597 2.403 9 9 9","key":"svg-0"}]]

/**
 * IconSparkle
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItc3BhcmtsZSIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMjEgMTJjLTYuNTk3IDAgLTkgMi40MDMgLTkgOWMwIC02LjU5NyAtMi40MDMgLTkgLTkgLTljNi41OTcgMCA5IC0yLjQwMyA5IC05YzAgNi41OTcgMi40MDMgOSA5IDkiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/sparkle
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconSparkle = createReactComponent('outline', 'sparkle', 'Sparkle', __iconNode);

export default IconSparkle;